
// filterChatsOldest: Función para filtrar los chats del más antiguo al más reciente.
export const filterChatsOldest = (chatsArray) =>{
    let orderedChats = chatsArray.sort((a, b) => new Date(a.FechaHora) - new Date(b.FechaHora));
    return orderedChats;
}